import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	display: flex;
	gap: 1rem;
	align-items: center;

	img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}

	@media (max-width: 1000px) {
		img {
			width: 3.5rem;
			height: 3.5rem;
		}
	}
`;

export const containerOpenModal = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	cursor: pointer;
`;

export const title = styled.p`
	font-size: 1.5rem;
	color: ${color.interface.lightGray};
	font-weight: 500;
	font-family: nunito-regular;
`;

export const button = styled.button`
	all: unset;
`;

export const contentModal = styled.div`
	border-radius: 5px;
	min-width: 180px;
	position: absolute;
	top: 150%;
	right: 0%;
	background-color: ${color.interface.white};
	padding: 1.5rem 0 1.5rem 0;
	box-sizing: border-box;
	-webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.21);
	box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.21);
	animation: ease 0.5s show;
	z-index: 1000 !important;

	@keyframes show {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}
`;

export const welcome = styled.p`
	margin: 0 2rem 0 2rem;
	font-family: nunito-bold;
	color: ${color.interface.darkgray};
	margin-bottom: 2rem;
`;

export const options = styled.div`
	margin: 0 2rem 0 2rem;
	font-family: nunito-bold;
	color: ${color.interface.darkgray};
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1rem;
	z-index: 100000;
	background-color: ${color.interface.white};
`;

export const line = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${color.interface.lightGray2};
	opacity: 0.5;
	margin-top: 2.5rem;
`;

export const option = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	cursor: pointer;

	p {
		font-size: 1.5rem;
		font-family: nunito-regular;
		color: ${color.interface.darkgray};
	}
`;

export const logout = styled.div`
	margin: 0 2rem 0 2rem;
	display: flex;
	align-items: center;
	gap: 1rem;
	margin-top: 2.5rem;
	cursor: pointer;
	p {
		font-size: 1.5rem;
		font-family: nunito-regular;
		color: ${color.interface.darkgray};
	}
`;
